import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { CompanyResponse } from '@/repositories/generated';

const response: CompanyResponse[] = [
  {
    id: '00001',
    name: 'モック企業1',
  },
  {
    id: '00002',
    name: 'モック企業2',
  },
  {
    id: '00003',
    name: 'モック企業3',
  },
];

export const autocompleteCompany = http.get(
  createMockEndpoint('/autocomplete/company'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
